<template>
    <div class="px-2 py-2 mt-4">
      <template>

        <div class="desktop-container">

            <v-list-item-group
            active-class="primary--text text--accent-4 "
            aria-label="Navigation Items"
            class="pl-4 pr-4"
            role="list"
            >

                  <v-list-item :to="{ name: 'about'}" data-cypress-value="about-page" role="listitem">
                    <v-list-item-title>
                        {{translations.home.labels.about}}
                    </v-list-item-title>
                    <i class="mdi mdi-open-in-new"></i>
                  </v-list-item>

                  <v-list-item :to="{ name: 'app_accessibility'}" data-cypress-value="accessibility-page" role="listitem">
                      <v-list-item-title>
                          {{translations.settings.titles.accessibility}}
                      </v-list-item-title>
                      <i class="mdi mdi-open-in-new"></i>
                  </v-list-item>

                  <v-list-item :to="{ name: 'app_terms'}" data-cypress-value="terms-page" role="listitem">

                    <v-list-item-title>
                        {{translations.consentpage.title}}
                    </v-list-item-title>
                    <i class="mdi mdi-open-in-new"></i>
                  </v-list-item>

                  <v-list-item :to="{ name: 'app_privacy'}" data-cypress-value="privacy-page" role="listitem">
                    <v-list-item-title>
                        {{translations.home.labels.privacy}}
                    </v-list-item-title>
                    <i class="mdi mdi-open-in-new"></i>
                  </v-list-item>

            </v-list-item-group>
          </div>
      </template>
    </div>
</template>
<style lang="scss" scoped>

.v-list-item {
  border: 2px solid $secondary;
  margin: 5px;

  &:hover, &:focus {
    background: $secondary;
    color: $dark;
  }
}
</style>
<script>
    import hubbdata from "@/hubbdata";

    export default {
        data: () => ({

        }),

        methods: {

        },
        computed: {
            translations() {
                return hubbdata.getters.translations;
            },

        },
        mounted: function() {
            ga('set', 'title', "Legal"); // eslint-disable-line
            ga('send', 'pageview', location.href); // eslint-disable-line
        }

  }
</script>
